import { DataStorage } from '../DataStorage';
const DEFAULT_TTL_IN_MINUTES = 10;
export class FlowAPIMemoryDataStorage extends DataStorage {
  constructor(flowAPI) {
    super();
    this.flowAPI = flowAPI;
  }
  get storage() {
    return this.flowAPI.controllerConfig.platformAPIs.storage.memory;
  }
  get isSSR() {
    return this.flowAPI.environment.isSSR;
  }
  get(key) {
    if (this.isSSR) {
      return null;
    }
    const data = this.storage.getItem(key);
    if (!data) {
      return null;
    }
    const {
      expiredTime,
      value
    } = JSON.parse(data);
    if (expiredTime && expiredTime < Date.now()) {
      this.delete(key);
      return null;
    }
    return value;
  }

  // TTL is only used in this storage since warmup data will be stored for approximately a week and if we will use TTL there it will not be valid for the whole week
  set(key, value, TTLInMinutes) {
    if (TTLInMinutes === void 0) {
      TTLInMinutes = DEFAULT_TTL_IN_MINUTES;
    }
    if (this.isSSR) {
      return;
    }
    const valueWithExpiredTime = {
      value,
      expiredTime: TTLInMinutes ? Date.now() + 1000 * 60 * TTLInMinutes : null
    };
    this.storage.setItem(key, JSON.stringify(valueWithExpiredTime));
  }
  delete(key) {
    if (this.isSSR) {
      return;
    }
    this.storage.removeItem(key);
  }
}
//# sourceMappingURL=FlowAPIMemoryDataStorage.js.map